(ns iris.posts.views.post-screening-options
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]
   [iris.hench :as hench]
   [iris.subs :as subs]
   [iris.posts.subs :as posts-subs]
   [iris.posts.events :as posts-events]
  ;;  [herb.core :refer [<class]]
   [iris.styles.posts :as $posts]
   [iris.posts.views.user-btn :refer [user-btn]]
   [clojure.string :as string]))

;; TODO: turn off raid subscriptions and change hench/eid-to-shaid to eid-len-raid

(defn post-screen [scopes-input disable-in actions notes]
  (re-frame/dispatch [::posts-events/screen-create  {:disable_in disable-in
                                                     :actions actions
                                                     :scopes_input scopes-input
                                                     :priority 0
                                                     :kind "catchall"
                                                     :notes notes
                                                     :enabled true
                                                     :target_level 0}]))

(defn prep-screen-notes [id forum type action]
  (str "Created for post " id " in forum " forum " by pressing the "
       (cond
         (and (= type "ip") (= action "ban")) "\"Ban IP\" button #bannedip"
         (and (= type "ip") (= action "quarantine")) "\"Quarantine IP\" button #quarantinedip"
         (and (= type "eid") (= action "quarantine")) "\"Quarantine EID\" button #quarantinedeid"
         (and (= type "2of3") (= action "quarantine")) "\"Quarantine 2/3\" button #quarantined2of3")))

(defn create-screen
  ([e val id forum action type disable-in actions]
   (.preventDefault e)
   (let [scopes-input val
         notes (prep-screen-notes id forum type action)]
     (post-screen scopes-input disable-in actions notes)))
  ([e val1 val2 val3 id forum action type disable-in actions]
   (.preventDefault e)
   (let [scopes-input (str forum " AND min2(" val1 " OR " val2 " OR " val3 ")")
         notes (prep-screen-notes id forum type action)]
     (post-screen scopes-input disable-in actions notes))))



(defn screening-status-class [ss]
  (cond (> (:n_enabled ss) 0)
        {:font-style "italic" :font-weight 700 :color "#a94442"}
        (> (:n_disabled ss) 0)
        {:color "#8a6d3b" :font-style "italic"}
        :else
        {}))


(defn geo-loc-btn [d]
  (when-let [ip (get-in d [:author :ip])]
    [:a.btn.btn-default
     {:target "ip2location"
      :title "Lookup IP geo location at ip2location.com"
      :href (str "http://www.ip2location.com/demo/" ip)}
     [:i.glyphicon.glyphicon-globe]]))

(defn cc-btn [d pfx]
  (when-let [cc (get-in d [:author :cc])]
    (let [country (get-in d [:author :country])
          ss (re-frame/subscribe [::posts-subs/screning-status (str ":" cc)])
          css (screening-status-class @ss)]
      [:a.btn.btn-default
       {:title country
        :href (str pfx "/cc/" cc)
        :style css}
       (str ":" cc)])))

;; (defn ip-btn [d raid]
;;   (when-let [ip (get-in d [:author :ip])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status (str "^" ip)])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {:title (str "IP address " ip)
;;         :href (str route-prefix "/ip/" ip)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :i_eid)}}])))

(defn ip-btn [d pfx]
  (when-let [ip (get-in d [:author :ip])]
    (let [i_eid (get-in d [:author :eid :i_eid])
          raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword i_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status (str "^" ip)])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title (str "IP address " ip)
        :href (str pfx "/ip/" ip)
        :style (merge {:min-width "35px"
                       :text-align
                       (if (some? raid) "center" "left")}
                      css)}
       (hench/eid-len-raid i_eid raid-len)])))

;; (defn g_eid-btn [d raid]
;;   (when-let [g_eid (get-in d [:author :eid :g_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status g_eid])
;;           css (screening-status-class @ss)
;;           geo (get-in d [:author :geo])]
;;       [:a.btn.btn-default
;;        {:title geo
;;         :href
;;         (str route-prefix "/eid/" g_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :g_eid)}}])))

(defn g_eid-btn [d pfx]
  (when-let [g_eid (get-in d [:author :eid :g_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword g_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status g_eid])
          css (screening-status-class @ss)
          geo (get-in d [:author :geo])
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title geo
        :href (str pfx "/eid/" g_eid)
        :style (merge {:min-width "35px"
                       :text-align
                       (if (some? raid) "center" "left")}
                      css)}
       (hench/eid-len-raid g_eid raid-len)])))

;; (defn c_eid-btn [d raid]
;;   (when-let [c_eid (get-in d [:author :eid :c_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status c_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {:title "Cookie EID"
;;         :href
;;         (str route-prefix "/eid/" c_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :c_eid)}}])))

(defn c_eid-btn [d pfx]
  (when-let [c_eid (get-in d [:author :eid :c_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword c_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status c_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title "Cookie EID"
        :href (str pfx "/eid/" c_eid)
        :style (merge {:min-width "35px"
                       :text-align
                       (if (some? raid) "center" "left")}
                      css)}
       (hench/eid-len-raid c_eid raid-len)])))



;; (defn f_eid-btn [d raid]
;;   (when-let [f_eid (get-in d [:author :eid :f_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status f_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {:title "BFP EID"
;;         :href
;;         (str route-prefix "/eid/" f_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :f_eid)}}])))

(defn f_eid-btn [d pfx]
  (when-let [f_eid (get-in d [:author :eid :f_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword f_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status f_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title "BFP EID"
        :href (str pfx "/eid/" f_eid)
        :style (merge {:min-width "35px"
                       :text-align
                       (if (some? raid) "center" "left")}
                      css)}
       (hench/eid-len-raid f_eid raid-len)])))


;; (defn d_eid-btn [d raid]
;;   (when-let [d_eid (get-in d [:author :eid :d_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status d_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {:title "DFP EID"
;;         :href
;;         (str route-prefix "/eid/" d_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :d_eid)}}])))

(defn d_eid-btn [d pfx]
  (when-let [d_eid (get-in d [:author :eid :d_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword d_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status d_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title "DFP EID"
        :href (str pfx "/eid/" d_eid)
        :style (merge {:min-width "35px"
                       :text-align
                       (if (some? raid) "center" "left")}
                      css)}
       (hench/eid-len-raid d_eid raid-len)])))

;; (defn a_eid-btn [d raid]
;;   (when-let [a_eid (get-in d [:author :eid :a_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status a_eid])
;;           css (screening-status-class @ss)
;;           ua (get-in d [:author :user_agent])]
;;       [:a.btn.btn-default
;;        {:title ua
;;         :href
;;         (str route-prefix "/eid/" a_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :a_eid)}}])))

(defn a_eid-btn [d pfx]
  (when-let [a_eid (get-in d [:author :eid :a_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword a_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status a_eid])
          css (screening-status-class @ss)
          ua (get-in d [:author :user_agent])
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:title ua
        :href (str pfx "/eid/" a_eid)
        :style (merge {:min-width "35px"
                       :text-align
                       (if (some? raid) "center" "left")}
                      css)}
       (hench/eid-len-raid a_eid raid-len)])))

;; (defn m_eid-btn [d raid]
;;   (when-let [m_eid (get-in d [:author :eid :m_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status m_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {;; :title "Accepts MIME type: '*/*'"
;;         :href (str route-prefix "/eid/" m_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :m_eid)}}])))

(defn m_eid-btn [d pfx]
  (when-let [m_eid (get-in d [:author :eid :m_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword m_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status m_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:href (str pfx "/eid/" m_eid)
        :style (merge {:min-width "35px"
                       :text-align
                       (if (some? raid) "center" "left")}
                      css)}
       (hench/eid-len-raid m_eid raid-len)])))


;; (defn l_eid-btn [d raid]
;;   (when-let [l_eid (get-in d [:author :eid :l_eid])]
;;     (let [ss (re-frame/subscribe [::posts-subs/screning-status l_eid])
;;           css (screening-status-class @ss)]
;;       [:a.btn.btn-default
;;        {;; :title "Accepts languages: 'en-US,en;q=0.9'"
;;         :href (str route-prefix "/eid/" l_eid)
;;         :style (merge {:min-width "35px"
;;                        :text-align
;;                        (if (some? raid) "center" "left")}
;;                       css)
;;         :dangerouslySetInnerHTML
;;         {:__html
;;          (hench/author-eid-raid d raid :l_eid)}}])))

(defn l_eid-btn [d pfx]
  (when-let [l_eid (get-in d [:author :eid :l_eid])]
    (let [raid @(re-frame/subscribe [::posts-subs/fb-data :eid-raid (keyword l_eid)])
          ss (re-frame/subscribe [::posts-subs/screning-status l_eid])
          css (screening-status-class @ss)
          raid-len @(re-frame/subscribe [::subs/raid-len])]
      [:a.btn.btn-default
       {:href (str pfx "/eid/" l_eid)
        :style (merge {:min-width "35px"
                       :text-align
                       (if (some? raid) "center" "left")}
                      css)}
       (hench/eid-len-raid l_eid raid-len)])))





(defn ban-ip-btn [d]
  (when-let [ip (get-in d [:author :ip])]
    (let [ss (re-frame/subscribe [::posts-subs/screning-status (str "^" ip)])
          enabled? (> (:n_enabled @ss) 0)
          btn-class (if enabled? "btn-default" "btn-danger")]
      ;; (if enabled?
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-default
      ;;    {:style {:cursor "auto"}}
      ;;    [:i.glyphicon.glyphicon-ban-circle]]
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
      ;;    {:title "Ban IP address for 7 days"
      ;;     :on-click (fn [e] (create-screen e
      ;;                                      (str "^" (get-in d [:author :ip]))
      ;;                                      (get-in d [:id])
      ;;                                      (get-in d [:forum])
      ;;                                      "ban"
      ;;                                      "ip"
      ;;                                      "7 d"
      ;;                                      [{:action "ban"}]))}
      ;;    [:i.glyphicon.glyphicon-ban-circle]])
      (reagent/with-let [clicked? (reagent/atom false)]
        [:a.btn.btn-grey-click.btn-disabled-click
         {:class (if @clicked? (string/join " " [btn-class "active"]) btn-class)
          :title "Ban IP address for 7 days"
          :on-click (fn [e] (create-screen e
                                           (str "^" (get-in d [:author :ip]))
                                           (get-in d [:id])
                                           (get-in d [:forum])
                                           "ban"
                                           "ip"
                                           "7 d"
                                           [{:action "ban"}])
                      (reset! clicked? true))}
         [:i.glyphicon.glyphicon-ban-circle]]))))


(defn q-ip-btn [d]
  (when-let [ip (get-in d [:author :ip])]
    (let [ss (re-frame/subscribe [::posts-subs/screning-status (str "^" ip)])
          enabled? (> (:n_enabled @ss) 0)
          btn-class (if enabled? "btn-default" "btn-danger")]

      ;; (if enabled?
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-default
      ;;    {:style {:cursor "auto"}}
      ;;    [:i.glyphicon.glyphicon-tower]]
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
      ;;    {:title "Quarantine IP for 6 months"
      ;;     :on-click (fn [e] (create-screen e
      ;;                                      (str "^" (get-in d [:author :ip]))
      ;;                                      (get-in d [:id])
      ;;                                      (get-in d [:forum])
      ;;                                      "quarantine"
      ;;                                      "ip"
      ;;                                      "6 m"
      ;;                                      [{:action "quarantine"
      ;;                                        :delay_min 60
      ;;                                        :delay_max 120}]))}
      ;;    [:i.glyphicon.glyphicon-tower]])


      (reagent/with-let [clicked? (reagent/atom false)]
        [:a.btn.btn-grey-click.btn-disabled-click
         {:class (if @clicked? (string/join " " [btn-class "active"]) btn-class)
          :title "Quarantine IP for 6 months"
          :on-click (fn [e] (create-screen e
                                           (str "^" (get-in d [:author :ip]))
                                           (get-in d [:id])
                                           (get-in d [:forum])
                                           "quarantine"
                                           "ip"
                                           "6 m"
                                           [{:action "quarantine"
                                             :delay_min 60
                                             :delay_max 120}])
                      (reset! clicked? true))}
         [:i.glyphicon.glyphicon-tower]]))))


(defn q-cookie-btn [d]
  (when-let [c_eid (get-in d [:author :eid :c_eid])]
    (let [ss (re-frame/subscribe [::posts-subs/screning-status c_eid])
          enabled? (> (:n_enabled @ss) 0)
          btn-class (if enabled? "btn-default" "btn-danger")]

      ;; (if enabled?
      ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-default
      ;;    {:style {:cursor "auto"}}
      ;;    [:i.glyphicon.glyphicon-tower]]
      ;;   [:a.btn.btn-danger.btn-grey-click.btn-disabled-click
      ;;    {:title "Quarantine cookie for 6 months"
      ;;     :on-click (fn [e] (create-screen e
      ;;                                      (get-in d [:author :eid :c_eid])
      ;;                                      (get-in d [:id])
      ;;                                      (get-in d [:forum])
      ;;                                      "quarantine"
      ;;                                      "eid"
      ;;                                      "6 m"
      ;;                                      [{:action "quarantine"
      ;;                                        :delay_min 60
      ;;                                        :delay_max 120}]))}
      ;;    [:i.glyphicon.glyphicon-tower]])


      (reagent/with-let [clicked? (reagent/atom false)]
        [:a.btn.btn-grey-click.btn-disabled-click
         {:class (if @clicked? (string/join " " [btn-class "active"]) btn-class)
          :title "Quarantine cookie for 6 months"
          :on-click (fn [e] (create-screen e
                                           (get-in d [:author :eid :c_eid])
                                           (get-in d [:id])
                                           (get-in d [:forum])
                                           "quarantine"
                                           "eid"
                                           "6 m"
                                           [{:action "quarantine"
                                             :delay_min 60
                                             :delay_max 120}])
                      (reset! clicked? true))}
         [:i.glyphicon.glyphicon-tower]]))))


(defn q-2-of-3 [d]
  (let [c_eid (get-in d [:author :eid :c_eid])
        f_eid (get-in d [:author :eid :f_eid])
        d_eid (get-in d [:author :eid :d_eid])
        forum (get-in d [:forum])

        ss-c_eid (re-frame/subscribe [::posts-subs/screning-status c_eid])
        ss-f_eid (re-frame/subscribe [::posts-subs/screning-status f_eid])
        ss-d_eid (re-frame/subscribe [::posts-subs/screning-status d_eid])
        ss-forum (re-frame/subscribe [::posts-subs/screning-status forum])

        enabled? (and (> (:n_enabled @ss-c_eid) 0)
                      (> (:n_enabled @ss-f_eid) 0)
                      (> (:n_enabled @ss-d_eid) 0)
                      (> (:n_enabled @ss-forum) 0))

        btn-class (if enabled? "btn-default" "btn-danger")]


    ;; (if enabled?
    ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-default
    ;;    {:style {:cursor "auto"}}
    ;;    [:i.glyphicon.glyphicon-tower]
    ;;    " ⅔\n\t\t\t"]
    ;;   [:a.btn.btn-grey-click.btn-disabled-click.btn-danger
    ;;    {:title (str "Quarantine 2 out of 3 (cookie, BFP, DFP) in forum " (get-in d [:forum]))
    ;;     :on-click (fn [e] (create-screen e
    ;;                                      (get-in d [:author :eid :c_eid])
    ;;                                      (get-in d [:author :eid :f_eid])
    ;;                                      (get-in d [:author :eid :d_eid])
    ;;                                      (get-in d [:id])
    ;;                                      (get-in d [:forum])
    ;;                                      "quarantine"
    ;;                                      "2of3"
    ;;                                      "6 m"
    ;;                                      [{:action "quarantine"
    ;;                                        :delay_min 60
    ;;                                        :delay_max 120}]))}
    ;;    [:i.glyphicon.glyphicon-tower]
    ;;    " ⅔\n\t\t\t"])


    (reagent/with-let [clicked? (reagent/atom false)]
      [:a.btn.btn-grey-click.btn-disabled-click
       {:class (if @clicked? (string/join " " [btn-class "active"]) btn-class)
        :title (str "Quarantine 2 out of 3 (cookie, BFP, DFP) in forum " (get-in d [:forum]))
        :on-click (fn [e] (create-screen e
                                         (get-in d [:author :eid :c_eid])
                                         (get-in d [:author :eid :f_eid])
                                         (get-in d [:author :eid :d_eid])
                                         (get-in d [:id])
                                         (get-in d [:forum])
                                         "quarantine"
                                         "2of3"
                                         "6 m"
                                         [{:action "quarantine"
                                           :delay_min 60
                                           :delay_max 120}])
                    (reset! clicked? true))}
       [:i.glyphicon.glyphicon-tower]
       " ⅔\n\t\t\t"])))


(defn post-screening-options
  ([d roles] (post-screening-options d roles ""))
  ([d roles pfx]
   (let [raid @(re-frame/subscribe [::posts-subs/fb-data :raid (keyword (:id d))])
         mobile @(re-frame/subscribe [::subs/mobile])
         screener (contains? roles "screener")
         tracker (contains? roles "tracker")
         by-staff (true? (get-in d [:author :staff]))]
     [:div.btn-group.btn-group-xs.ip-buttons
      {:role "group"
       :class ($posts/$post-screening-options mobile)}
      (if by-staff
        [:<>
         (when tracker
           [:<>
            [cc-btn d pfx]
            [g_eid-btn d pfx]
            [geo-loc-btn d]
            [ip-btn d pfx]
            [c_eid-btn d pfx]
            [f_eid-btn d pfx]
            [d_eid-btn d pfx]
            [a_eid-btn d pfx]
            [m_eid-btn d pfx]
            [l_eid-btn d pfx]])
         [user-btn (get-in d [:author :uid]) pfx]]
        [:<>
         [cc-btn d pfx]
         [g_eid-btn d pfx]
         [geo-loc-btn d]
         (when screener [ban-ip-btn d])
         [ip-btn d pfx]
         (when screener [q-ip-btn d])
         [c_eid-btn d pfx]
         (when screener [q-cookie-btn d])
         [f_eid-btn d pfx]
         [d_eid-btn d pfx]
         (when screener [q-2-of-3 d])
         [a_eid-btn d pfx]
         [m_eid-btn d pfx]
         [l_eid-btn d pfx]])])))
